/**
 * The only module that reads `import.meta.env`. Everything configurable about this application is
 * resolved here, once.
 */
export class Config {
	#api: string;
	/**
	 * Where the Snapshots service is reached; the session lives in its cookie. Empty, the default, is this
	 * page's own origin: the development server proxies `/v1` to the service
	 */
	get api() {
		return this.#api;
	}

	#projects: string;
	/**
	 * The Beyond Projects interface, where the family bar's wordmark and its one Projects entry lead while
	 * the bar's descriptor cannot be read. Empty, the default, is this application's own home: the
	 * descriptor's own `links.home` wins whenever it is read
	 */
	get projects() {
		return this.#projects;
	}

	#packages: string;
	/**
	 * The Packages interface, where the arrival line of a capture opened from Packages leads back, with
	 * the capture's organization and project, when the family bar's descriptor names no Packages entry.
	 * Empty, the default, draws no way back to Packages
	 */
	get packages() {
		return this.#packages;
	}

	constructor(values: Record<string, string | undefined> = import.meta.env as unknown as Record<string, string | undefined>) {
		this.#api = (values.VITE_SNAPSHOTS_API ?? '').replace(/\/$/, '');
		this.#projects = (values.VITE_SNAPSHOTS_PROJECTS ?? '').replace(/\/$/, '');
		this.#packages = (values.VITE_SNAPSHOTS_PACKAGES ?? '').replace(/\/$/, '');
	}
}

export const config = new Config();
